import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Handles coupon copy UX and variant-aware discounted pricing for PDP discount block.
 * @extends {Component}
 */
class ProductDiscountCode extends Component {
  /** @type {ReturnType<typeof setTimeout> | null} */
  #copiedTimeout = null;

  connectedCallback() {
    super.connectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.updateContentFromVariant);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.updateContentFromVariant);
    if (this.#copiedTimeout) {
      clearTimeout(this.#copiedTimeout);
    }
  }

  copyCouponCode = async () => {
    const copyButton = this.refs.copyButton;
    if (!(copyButton instanceof HTMLElement)) return;

    const code = copyButton.dataset.couponCode;
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
      this.dataset.copied = 'true';
      if (this.#copiedTimeout) {
        clearTimeout(this.#copiedTimeout);
      }
      this.#copiedTimeout = setTimeout(() => {
        this.dataset.copied = 'false';
      }, 3000);
    } catch (error) {
      // Keep silent fallback for unsupported clipboard APIs.
    }
  };

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateContentFromVariant = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newComponent = event.detail.data.html.querySelector(`product-discount-code[data-block-id="${this.dataset.blockId}"]`);
    if (!newComponent) return;

    const currentContent = this.refs.contentContainer;
    const newContent = newComponent.querySelector('[ref="contentContainer"]');
    if (currentContent instanceof Element && newContent instanceof Element) {
      currentContent.replaceWith(newContent);
    }
  };
}

if (!customElements.get('product-discount-code')) {
  customElements.define('product-discount-code', ProductDiscountCode);
}
